import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getCheckoutResultsApi,
  getDeliveryTrackingLinkApi,
  RequestType,
  verifyAuthenticateTokenApi
} from 'src/services/oms'
import { mockCheckoutResult } from 'src/services/mock'
import { isEmpty } from 'src/utils/string'
import type { CustomisationStateInReducer } from '../customisation'

export const getCheckoutResultsAction = createAsyncThunk(
  '@thankyou/getCheckoutResults',
  async (
    {
      req,
      storeOrderId,
      isServer = false
    }: { req?: RequestType; storeOrderId: string; isServer?: boolean },
    thunkApi
  ) => {
    const state = thunkApi.getState() as CustomisationStateInReducer
    const previewMode = state['@customisation'].data.previewMode
    if (previewMode) {
      return mockCheckoutResult
    }
    if (!previewMode && isEmpty(storeOrderId)) {
      return { success: false, error: 'Missed storeOrderId' }
    }
    const result = await getCheckoutResultsApi({ storeOrderId, req, isServer })
    return result.data
  }
)

export const verifyAuthenticateTokenAction = createAsyncThunk(
  '@thankyou/verifyAuthenticateToken',
  async ({
    req,
    storeOrderId,
    token,
    isServer = false
  }: {
    req?: RequestType
    storeOrderId: string
    token: string
    isServer?: boolean
  }) => {
    const result = await verifyAuthenticateTokenApi({
      req,
      storeOrderId,
      token,
      isServer
    })
    return result.data
  }
)

export const getDeliveryTrackingLinkAction = createAsyncThunk(
  '@thankyou/getDeliveryTrackingLink',
  async ({
    req,
    storeOrderId,
    isServer = false
  }: {
    req?: RequestType
    storeOrderId: string
    isServer?: boolean
  }) => {
    const result = await getDeliveryTrackingLinkApi({
      req,
      storeOrderId,
      isServer
    })
    return result.data
  }
)
